import {Button, Checkbox, Col, message, Popover, Radio, Row, Spin, Tooltip} from 'antd';
import React, {Component} from 'react';
import cookie from "react-cookies";
import {connect} from "react-redux";
import '../../../asset/style/workflow/set-params.css';
import {get} from "../../../helper/request";
import {
    initPreviewForScan,
    saveSelectedPreviewsForTuning,
    setScanSpeedForAllSlots,
    setSpecimenTypeForAllSlots,
    startScanning,
    takeSelectedPreview,
    updatePreviewStatus
} from "../../../redux_actions/preview_status.action";
import {RegionSelectionConstants} from "../../../redux_constants/region_selection.constant";
import {
    cassetteType,
    deviceType,
    objectiveType,
    progressStage,
    scanSpeed,
    slideType,
    specimenType
} from '../../../utils/const';
import {getKeyByValue, getSupportedSpecimenType, isNull, isTrue, openEndPoint} from '../../../utils/utils';
import SlotComponent from '../slot_component_new';
import LoadSlidesPrompt from './loadSlidesPrompt';
import {getRadioButtons} from "./scan_workflow_utils";
import SlideView from './slide_view';
import {error_manager} from "../../../helper/error_manager";
import {aclPermissions, hasPermissions} from "../../../const/ACLPermissions";

let SPECIMEN = {
    'PAP': specimenType.PAP,
    'HE': specimenType.HNE_TISSUE,
    'IHC': specimenType.IHC,
    'BM': specimenType.BM,
    'BLOOD': specimenType.BLOOD,
}

let SCAN_SPEED = {
    'Minor': scanSpeed.FAST,
    'Few': scanSpeed.MEDIUM,
    'Major': scanSpeed.SLOW,
    'ZSTACK': scanSpeed.ZSTACK,
}

let OBJECTIVE = {
    '20x': objectiveType.TWENTY_X,
    '40x': objectiveType.FORTY_X,
    '100x': objectiveType.HUNDRED_X,
}

let ALL_SLOTS_SELECTED = [true, true, true, true, true, true]
let ALL_SLOTS_UNSELECTED = [false, false, false, false, false, false]


class SetScanParamsView extends Component {
    constructor(props) {
        super(props)

        let cassetteSizeArray = [];
        for (let i = 0; i < this.props.deviceProperties.cassetteSize; i++) {
            cassetteSizeArray.push(i);
        }

        this.state = {
            specimenType: ((this.props.deviceProperties || {}).defaultConfig || {}).specimenType,
            scanSpeed: ((this.props.deviceProperties || {}).defaultConfig || {}).scanSpeed,
            objectiveType: getKeyByValue(OBJECTIVE, ((this.props.deviceProperties || {}).defaultConfig || {}).objectiveType),
            expandedSlide: false,
            selectedSlots: ALL_SLOTS_UNSELECTED,
            isFetching: false,
            isFetchingAllPreviews: false,
            slotIndexes: this.props.deviceProperties.deviceType === deviceType.MORPHOLENS_1 || this.props.deviceProperties.deviceType === deviceType.HEMOLENS_1 ? [0] : cassetteSizeArray,
            device_id: 1,
            totalSelectedSlots: 0,
            cassetteSize: this.props.deviceProperties.cassetteSize,
            selectedSlotIndex: this.props.deviceProperties.cassetteSize === 1 ? 0 : -1,
            defaultConfig: this.props.deviceProperties.defaultConfig,
            listNameInvalid: [],
        };
        this.slideElement = {
            0: React.createRef(),
            1: React.createRef(),
            2: React.createRef(),
            3: React.createRef(),
            4: React.createRef(),
            5: React.createRef(),
        }
    }

    onCheckName = (val, key) => {
        let newlist = this.state.listNameInvalid
        if (newlist.includes(key)) {
            if (!val) {
                const id = newlist.indexOf(key);
                const removed = newlist.splice(id, 1);
            }
        } else {
            if (val) {
                newlist.push(key)
            }
        }
        this.setState({
            listNameInvalid: newlist
        })
    }

    componentDidCatch(error, errorInfo) {
    	openEndPoint('/scanners/' + this.props.device_id, false, true);
    }

    componentDidMount = () => {
        let supportedSpecs = (((this.props.deviceStatus[this.props.device_id] || {}).scanner_health || {}).scanner_response||{}).supportedSpecimenTypes
        if (supportedSpecs!==undefined) {
        SPECIMEN = getSupportedSpecimenType(SPECIMEN, supportedSpecs, true);
        }
        let cassetteSizeArray = [];
        let cassetteSize = this.props.scannerProperties.cassetteSize;
        if (this.props.cassetteType === cassetteType.TWO_2_BY_3_SLIDES) {
            cassetteSize = this.props.scannerProperties.cassetteSize2by3;
        }
        for (let i = 0; i < cassetteSize; i++) {
            cassetteSizeArray.push(i);
        }

        // update cassette type and slot size
        this.setState({
            slotIndexes: cassetteSizeArray
        });
    }

    componentDidUpdate = (prevProps) => {
        if (prevProps.cassetteType !== this.props.cassetteType) {
            let cassetteSizeArray = [];
            let cassetteSize = this.props.scannerProperties.cassetteSize;
            if (this.props.cassetteType === cassetteType.TWO_2_BY_3_SLIDES) {
                cassetteSize = this.props.scannerProperties.cassetteSize2by3;
            }
            for (let i = 0; i < cassetteSize; i++) {
                cassetteSizeArray.push(i);
                this.props.dispatch(initPreviewForScan(i, this.props.defaultConfig));
            }

            // update cassette type and slot size
            this.setState({
                slotIndexes: cassetteSizeArray
            });
        }
        if ((prevProps.deviceStatus.uiBusy || {}).status === true && (this.props.deviceStatus.uiBusy || {}).status === false) {
            this.setState({
                isFetching: false,
            })
        }
        if ((((this.props.deviceStatus[this.props.device_id] || {}).scanner_health || {}).scanner_response||{}).supportedSpecimenTypes !== 
        (((prevProps.deviceStatus[this.props.device_id] || {}).scanner_health || {}).scanner_response||{}).supportedSpecimenTypes) {
            const supportedSpecs = (((this.props.deviceStatus[this.props.device_id] || {}).scanner_health || {}).scanner_response||{}).supportedSpecimenTypes
            SPECIMEN = getSupportedSpecimenType(SPECIMEN, supportedSpecs, true);
        }
    }

    setAllTissueType = (value) => {
        this.setState({
            specimenType: value,
        });
        this.props.dispatch(setSpecimenTypeForAllSlots(value));
    }

    setAllScanSpeed = (value) => {
        this.setState({
            scanSpeed: value,
        });
        this.props.dispatch(setScanSpeedForAllSlots(value));
    }

    synchromnise_bool_and_confirmed = () => {
        let selectedSlots = [...this.state.selectedSlots];
        for (let idx = 0; idx < selectedSlots.length; idx++) {
            if (selectedSlots[idx] === true) {
                console.log(idx, "update")
                // this.props.dispatch(updatePreviewStatus(selectedSlots[idx], RegionSelectionConstants.CONFIRMED))
            }
        }
    }

    toggleCheckbox = (index) => {
        let selectedSlots = [...this.state.selectedSlots];
        selectedSlots[index] = !selectedSlots[index]
        this.setState({
            selectedSlots: selectedSlots
        });

        if ((this.props.previews[index].status === RegionSelectionConstants.CONFIRMED || this.props.previews[index].status === RegionSelectionConstants.FETCHED_IMAGE) && (this.props.deviceType !== deviceType.HEMOLENS_1 || this.props.deviceType !== deviceType.MORPHOLENS_1)) {
            let temp = this.state.listNameInvalid;
            if (temp.includes(index)) {
                let id = temp.indexOf(index)
                temp.splice(id, 1);
                this.setState({listNameInvalid: temp})
            }

            let url = "/server/devices/" + this.state.device_id + "/clear_slot/?slotID=" + index;
            get(url)
                .then(res => {
                    this.props.dispatch(initPreviewForScan(index, this.props.defaultConfig));
                }).catch(err => error_manager("", err))

        } else {
            this.props.previews[index].status = RegionSelectionConstants.CONFIRMED;
        }
        this.slideElement[index].current.toggleSelection();
    }

    toggleAllCheckbox = () => {
        if (this.state.selectedSlots === ALL_SLOTS_SELECTED) {
            for (let index = 0; index < this.state.slotIndexes.length; index++) {
                if (this.props.previews[index].response !== undefined) {
                    this.props.previews[index].status = RegionSelectionConstants.FETCHED_IMAGE
                } else {
                    this.props.previews[index].status = RegionSelectionConstants.NOT_STARTED
                }
                this.slideElement[index].current.toggleSelection();
            }
        } else {
            for (let index = 0; index < this.state.slotIndexes.length; index++) {
                this.props.previews[index].status = RegionSelectionConstants.CONFIRMED;
                this.slideElement[index].current.toggleSelection();
            }
        }
        this.setState({
            selectedSlots: this.state.selectedSlots === ALL_SLOTS_SELECTED ? ALL_SLOTS_UNSELECTED : ALL_SLOTS_SELECTED
        })
    }

    expandedSlideView = (key) => {
        if (this.props.previews[key].status === RegionSelectionConstants.SELECTION_DONE || this.props.previews[key].status === RegionSelectionConstants.CONFIRMED) {
            this.props.dispatch(updatePreviewStatus(key, RegionSelectionConstants.FETCHED_IMAGE));
        }
        this.setState({
            selectedSlotIndex: key, expandedSlide: true,
        });
    }

    closeExpadedSlideView = () => {
        this.setState({
            expandedSlide: false,
        });
    }

    beforePreview = (isBarcodeRead=true, isBarcodeReadOcr=true) => {
        let goScan = false;
        for (let i = 0; i < Object.keys(this.props.previews || {}).length - 1; i++) {
            if ((this.props.previews[i] || {}).status === RegionSelectionConstants.CONFIRMED && !((this.props.previews[i] || {}).dropDistancePoint !== undefined && (this.props.previews[i] || {}).dropDistancePoint.length > 0)) {
                goScan = true;
            }
        }

        if (goScan === true) {
            this.takeSelectedPreviewss(isBarcodeRead,isBarcodeReadOcr);
        } else {
            message.error("Scan Area Selection Already Done for the selected slots! Can't take Preview Again.")
        }
    }

    savePreviewsForTuning = () => {
        let selectedSlots = [];
        console.debug("[savePreviewsForTuning] this.state.cassetteSize is ", this.state.cassetteSize);
        for (let i = 0; i < this.state.cassetteSize; i++) {
            console.debug("[savePreviewsForTuning] this.props.previews[i]", this.props.previews[i]);
            if((this.props.previews[i].status === RegionSelectionConstants.CONFIRMED
                || this.props.previews[i].status === RegionSelectionConstants.FETCHED_IMAGE)) {
                selectedSlots.push(i);
            }
        }
        console.log("[savePreviewsForTuning] selectedSlots", selectedSlots);
        this.props.dispatch(saveSelectedPreviewsForTuning(this.props.device_id, selectedSlots));
    }

    takeSelectedPreviewss = (isBarcodeRead, isBarcodeReadOcr) => {
        this.setState({
            isFetchingAllPreviews: true,
        });
        let selectedSlots = [];
        for (let i = 0; i < this.state.cassetteSize; i++) {
            if (this.props.previews[i].status === RegionSelectionConstants.CONFIRMED && !((this.props.previews[i] || {}).dropDistancePoint !== undefined && (this.props.previews[i] || {}).dropDistancePoint.length > 0)) {
                selectedSlots.push(i)
            }
        }
        this.props.dispatch(takeSelectedPreview(this.props.device_id, selectedSlots, this.synchromnise_bool_and_confirmed, false, isBarcodeRead, isBarcodeReadOcr));
        this.setState({
            selectedSlots: ALL_SLOTS_UNSELECTED,
        })
    }

    onStartScanning = () => {
        let goScan = false;
        for(let i=0; i < Object.keys(this.props.previews || {}).length-1; i++) {
            const isReadyToScan =  [RegionSelectionConstants.CONFIRMED, RegionSelectionConstants.FETCHED_IMAGE, RegionSelectionConstants.COARSE_STARTED, RegionSelectionConstants.COARSE_DONE, RegionSelectionConstants.SELECTION_DONE].includes(this.props.previews[i]?.status)
            if (isReadyToScan) {
                goScan = true;
                break;
            }
        }

        if (goScan === true) {
            this.props.dispatch(startScanning(this.state.device_id, this.props.previews, this.props.bloodConfig));
            this.props.handleProgressChange(progressStage.SCANNING);
        } else {
            message.error("Please select atleast one slot before starting scan.")
        }
    }

    render() {
        let isFetchingAllPreviews = false;
        let barcodeVerify=((this.props.deviceStatus[this.props.device_id] || {}).scanner_health || {}).verify_barcode;
        let preventScan=((this.props.deviceStatus[this.props.device_id] || {}).scanner_health || {}).invalid_barcode_prevents_scan;
        let currPreviewStatus = (((this.props.deviceStatus[this.props.device_id] || {}).scanner_health || {}).scanner_response|| {}).scanPreviewStatus;
        if (isNull(currPreviewStatus)) {
            //TODO: show a generic page
            return;
        }

        let slotsWithEnoughScanArea = 0;
        for (const [key, value] of Object.entries(currPreviewStatus)) {
            if (value.previewOngoing) {
                isFetchingAllPreviews = true;
                break;
            }
        }

        for (const [key, value] of Object.entries(currPreviewStatus)) {
            if ((value.previewResponse || {}).enoughScanArea === true) {
                slotsWithEnoughScanArea += 1;
            }
        }

        let totalSelectedSlots = 0, totalScannableSlots = 0, totalSelectedSlotsApplicableForPreview = 0;
        for (let id in this.props.previews) {
            if ((this.props.previews[id] || {}).status === RegionSelectionConstants.CONFIRMED || (this.props.previews[id] || {}).status === RegionSelectionConstants.FETCHED_IMAGE) {
                totalSelectedSlots++;

                // if direct scan
                totalScannableSlots++;
                totalSelectedSlotsApplicableForPreview++;
                if(currPreviewStatus[id] === undefined){
                    slotsWithEnoughScanArea += 1;
                }
            }
        }

        const specimenOptions = (<div style={{padding: '2px 0px'}}>
            <Radio.Group size={'small'} value={this.state.specimenType}
                         onChange={(e) => {
                             e.stopPropagation();
                             this.setAllTissueType(e.target.value)
                         }}
            >
                {getRadioButtons(SPECIMEN, this.state.specimenType)}
            </Radio.Group>
        </div>)

        const scanSpeedOptions = (<div style={{padding: '2px 0px'}}>
            <Radio.Group size={'small'} value={this.state.scanSpeed} onChange={(e) => {
                e.stopPropagation();
                this.setAllScanSpeed(e.target.value)
            }}>
                {getRadioButtons(SCAN_SPEED, this.state.scanSpeed)}
            </Radio.Group>
        </div>)
        let SlideType = this.props.cassetteType === cassetteType.SIX_1_BY_3_SLIDES ? slideType.SLIDE_1_BY_3_INCH : slideType.SLIDE_2_BY_3_INCH;
        let slides = this.state.slotIndexes.map((index) => {
            let checkSelected = (this.props.previews[index] || {}).status === RegionSelectionConstants.CONFIRMED || (this.props.previews[index] || {}).status === RegionSelectionConstants.FETCHED_IMAGE;
            return <>
                <Col
                    span={this.props.deviceProperties.deviceType === deviceType.MORPHOLENS_1 || this.props.deviceProperties.deviceType === deviceType.HEMOLENS_1 ? 5 :
                        ( this.props.cassetteType === cassetteType.SIX_1_BY_3_SLIDES ? 4 : 5 )}
                    offset={this.props.cassetteType === cassetteType.SIX_1_BY_3_SLIDES ? 0 : 5}
                    align={'middle'} justify={'center'}
                    className={this.state.selectedSlotIndex === index && this.state.expandedSlide === true ? "active-slot" : ""}>
                    <SlideView
                        barcodeVerify={barcodeVerify}
                        onNameValid={this.onCheckName}
                        key={index}
                        ref={this.slideElement[index]}
                        expandedSlide={this.state.expandedSlide}
                        expandedSlideView={this.expandedSlideView}
                        slot_id={index}
                        defaultConfig={this.state.defaultConfig}
                        device_id={this.state.device_id}
                        slideType={SlideType}/>
                    <Button className={checkSelected ? "select-button shutdown-scanner-btn" : "select-button"}
                            size="small"
                            type={checkSelected ? "danger" : "primary"}
                            ghost={!checkSelected}
                            onClick={(e) => {
                                e.stopPropagation();
                                this.toggleCheckbox(index)
                            }}
                            disabled={isFetchingAllPreviews}>
                        {checkSelected ? "Remove" : "Select"}
                        {/* {(this.state.selectedSlots[index])?"Remove":"Select"} */}
                    </Button>
                </Col>
            </>
        });

        const autoPreviewThreshold = (((this.props.deviceStatus[this.props.device_id] || {}).scanner_health || {}).scanner_response|| {}).autoPreviewThreshold;
        const canReadBarcodeWithPreview = hasPermissions([aclPermissions.read_barcode_with_preview]);

        let runningAdvancedMode = (((this.props.deviceStatus[this.props.device_id] || {}).scanner_health || {}).scanner_response|| {})['runningAdvancedMode'];
        return (
            <div className="relative-position">
                <div className={this.props.currentProcessIndex !== progressStage.LOAD_SLIDES ? "" : "blur"}>
                    { !(this.state.expandedSlide) ?
                        <div style={{marginTop: 30}}>
                            <Row>
                                <Col
                                    offset={this.props.deviceProperties?.deviceType === deviceType.MORPHOLENS_1 || this.props.deviceProperties?.deviceType === deviceType.HEMOLENS_1 ? 10 : 0}
                                    span={this.props.deviceProperties?.deviceType === deviceType.MORPHOLENS_1 || this.props.deviceProperties?.deviceType === deviceType.HEMOLENS_1 ? 14 : 23}>
                                    <Row>
                                        {slides}
                                    </Row>
                                </Col>
                                {this.state.cassetteSize !== 1 && <Col span={1}>
                                    <div className="default-settings">
                                        <div style={{height: '206px'}}>
                                            <p style={{
                                                transform: 'rotate(-90deg)',
                                                fontSize: '24px',
                                                marginTop: '300px'
                                            }}>Defaults</p>
                                        </div>
                                        <div style={{justify: 'center', borderTop: '2px solid black'}}>
                                            {autoPreviewThreshold !== true ?
                                                <Popover content={specimenOptions} overlayStyle={{width: '250px', textAlign: 'center'}}
                                                         title={'Set Specimen Type'}>
                                                    <div style={{
                                                        borderBottom: '1px solid grey',
                                                        textAlign: 'center',
                                                        padding: '3px'
                                                    }}>
                                                        {getKeyByValue(SPECIMEN, this.state.specimenType)}
                                                    </div>
                                                </Popover> : null}
                                            <Popover content={scanSpeedOptions} overlayStyle={{width: '250px', textAlign: 'center'}}
                                                     title={'Select Tissue Artifacts Level'}>
                                                <div style={{
                                                    borderBottom: '1px solid grey',
                                                    textAlign: 'center',
                                                    padding: '3px'
                                                }}>
                                                    {getKeyByValue(SCAN_SPEED, this.state.scanSpeed)}
                                                </div>
                                            </Popover>
                                            {/*<Popover content={objectiveTypeOptions} title={'Select Objective'}>
                                            <div style={{borderBottom: '1px solid grey', textAlign: 'center', padding: '3px'}}>
                                                {this.state.objectiveType}
                                            </div>
                                        </Popover> */}
                                        </div>
                                    </div>
                                    <Checkbox className="checkbox"
                                              indeterminate={totalSelectedSlots !== 0 && totalSelectedSlots !== 6}
                                              checked={totalSelectedSlots === 6}
                                              onClick={this.toggleAllCheckbox}
                                              style={{marginLeft: '30px'}}></Checkbox>
                                </Col>}
                            </Row>
                            <Row style={{ marginTop: 50}} className={"actionable-buttons-parent-div-set-params"}>
                                {canReadBarcodeWithPreview &&
                                    <Col span={5} offset={isTrue(cookie.load("superuser")) ? 0 : 3}>
                                        <Button onClick={() => this.beforePreview(false, false)} style={{marginLeft: 25}}
                                                className="actionable-buttons-set-params black-scanner-btn"
                                                disabled={totalSelectedSlotsApplicableForPreview === 0 || (this.props.deviceStatus[this.props.device_id] || {}).uiBusy || isFetchingAllPreviews || runningAdvancedMode}>
                                            Take Preview w/o Read Barcode
                                        </Button>
                                    </Col>}
                                {canReadBarcodeWithPreview &&
                                    <Col span={5}>
                                        <Button onClick={() => this.beforePreview(true, false)} style={{marginLeft: 25}}
                                                className="actionable-buttons-set-params black-scanner-btn"
                                                disabled={totalSelectedSlotsApplicableForPreview === 0 || (this.props.deviceStatus[this.props.device_id] || {}).uiBusy || isFetchingAllPreviews || runningAdvancedMode}>
                                            Take Preview with Read Barcode
                                        </Button>
                                    </Col>}
                                <Col span={5} offset={!canReadBarcodeWithPreview && (this.state.cassetteSize === 1 &&
                                isTrue(cookie.load("superuser")) ? 5 : this.state.cassetteSize === 1 ? 7 : 0)}>
                                    <Button onClick={() => this.beforePreview(true, true)} style={{marginLeft: 25}}
                                            className="actionable-buttons-set-params black-scanner-btn"
                                            disabled={totalSelectedSlotsApplicableForPreview === 0 || (this.props.deviceStatus[this.props.device_id] || {}).uiBusy || isFetchingAllPreviews || runningAdvancedMode}>
                                        {canReadBarcodeWithPreview ? "Take Preview & Barcode with OCR" :
                                            <>Take Preview {this.state.cassetteSize === 1 ? "" : (`${totalSelectedSlotsApplicableForPreview} 
                                                ${totalSelectedSlotsApplicableForPreview <= 1 ? "Preview" : "Previews"} Selected`)}
                                            </>}
                                    </Button>
                                </Col>
                                <Col span={isTrue(cookie.load("superuser")) ? 5 : 12}>
                                    {(slotsWithEnoughScanArea < totalScannableSlots) ? <Tooltip placement="bottom"
                                             title={"Make sure all selected slots have tissue marked"}>
                                        <span className={"black-scanner-btn"}>
                                            <Button onClick={this.onStartScanning}
                                                    className="actionable-buttons-set-params black-scanner-btn"
                                                    disabled={(slotsWithEnoughScanArea < totalScannableSlots) || totalScannableSlots === 0 ||
                                                        (this.props.deviceStatus[this.props.device_id] || {}).uiBusy || isFetchingAllPreviews || runningAdvancedMode || (preventScan && (this.state.listNameInvalid.length !== 0 && barcodeVerify))}>
                                                Scan Now {this.state.cassetteSize === 1 ? "" : (`${totalScannableSlots} ${totalScannableSlots <= 1 ? "Slot" : "Slots"} Selected`)}
                                            </Button>
                                        </span>
                                    </Tooltip>  :
                                    <Button onClick={this.onStartScanning}
                                            className="actionable-buttons-set-params black-scanner-btn"
                                            disabled={(slotsWithEnoughScanArea < totalScannableSlots) || totalScannableSlots === 0 ||
                                                (this.props.deviceStatus[this.props.device_id] || {}).uiBusy || isFetchingAllPreviews || runningAdvancedMode || (preventScan && (this.state.listNameInvalid.length !== 0 && barcodeVerify))}>
                                        Scan Now {this.state.cassetteSize === 1 ? "" : (`${totalScannableSlots} ${totalScannableSlots <= 1 ? "Slot" : "Slots"} Selected`)}
                                    </Button>}
                                </Col>
                                {isTrue(cookie.load("superuser")) ?
                                    <Col span={4}>
                                        <Button onClick={this.savePreviewsForTuning}
                                                className="actionable-buttons-set-params black-scanner-btn"
                                                disabled={totalSelectedSlotsApplicableForPreview === 0 || (this.props.deviceStatus[this.props.device_id] || {}).uiBusy || isFetchingAllPreviews || runningAdvancedMode}>
                                            Save {totalSelectedSlotsApplicableForPreview} {totalSelectedSlotsApplicableForPreview <= 1 ? `Preview` : `Previews`} for Tuning
                                        </Button>
                                    </Col> : null}
                            </Row>
                        </div>
                    :
                        (this.props.currentProcessIndex !== progressStage.LOAD_SLIDES && !(((this.props.deviceStatus[this.props.device_id] || {}).scanner_health || {}).scanner_response|| {}).scanning) ?
                            <div>
                                <Row>
                                    <div className='editing-pane'>
                                        <SlotComponent id={this.state.selectedSlotIndex}
                                                       device_id={this.props.device_id}
                                                       defaultConfig={this.state.defaultConfig}
                                                       cassetteSize={this.state.cassetteSize}
                                                       startScanning={this.onStartScanning}
                                                       closeExpadedSlideView={this.closeExpadedSlideView}
                                                       slideType={SlideType}
                                        />
                                    </div>
                                </Row>
                            </div>
                            : this.props.navigateToScannerDashboard()
                    }
            </div>
            {this.props.currentProcessIndex === progressStage.LOAD_SLIDES ?
            <LoadSlidesPrompt
                handleProgressChange={this.props.handleProgressChange}
                currentProcessIndex={this.props.currentProcessIndex}
                cassetteSize={this.state.cassetteSize}
                detectingCassette={this.props.detectingCassette}
                askUserCassetteType={this.props.askUserCassetteType}
                setCassetteType={this.props.setCassetteType}
                setDetectingCassette={this.props.setDetectingCassette}
            /> : null}
        </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        previews: state.previewStatusReducer,
        deviceStatus: state.deviceStatusReducer,
        bloodConfig: state.bloodConfigReducer,
        deviceProperties: state.deviceAlert.deviceProperties,
    };
};

export default connect(mapStateToProps)(SetScanParamsView);